import { css } from 'styled-components';

import breakpoints from '../constants/tokens/breakpoints';
import { SpacingPattern, TypographyToken } from '../constants/theme';

// For typography or spacing patterns. See generateColorStyleFromPattern for color patterns
export const generateStyleFromPattern = (patternsOfType: any, patternName: string) => {
  const pattern: TypographyToken & SpacingPattern = patternsOfType[patternName];
  let cssStr = '';
  for (const [prop, value] of Object.entries(pattern)) {
    if (!Object.keys(breakpoints).includes(prop)) {
      cssStr += generateStyleFromPatternAtBreakpoint(prop, value as string);
    } else {
      cssStr += `@media (min-width: ${breakpoints[prop]}) {`;
      for (const [propAtBreakpoint, valueAtBreakpoint] of Object.entries(value)) {
        cssStr += generateStyleFromPatternAtBreakpoint(propAtBreakpoint, valueAtBreakpoint);
      }
      cssStr += `}`;
    }
  }
  return css`${cssStr}`;
};

const generateStyleFromPatternAtBreakpoint = (prop: string, value: string) => {
  const cssDeclaration: { [prop: string]: string } = {};
  cssDeclaration[prop] = value;
  return css`${cssDeclaration}`;
}
